export const EDITOR_CUT = 'EDITOR_CUT';
export const EDITOR_COPY = 'EDITOR_COPY';
export const EDITOR_PASTE = 'EDITOR_PASTE';
export const EDITOR_UNDO = 'EDITOR_UNDO';
export const EDITOR_UNDO_SUCCESS = 'EDITOR_UNDO_SUCCESS';
export const EDITOR_REDO = 'EDITOR_REDO';
export const EDITOR_REDO_SUCCESS = 'EDITOR_REDO_SUCCESS';
export const EDITOR_CLOSED = 'EDITOR_CLOSED';
export const EDITOR_KEYBOARD_DELETE = 'EDITOR_KEYBOARD_DELETE';
export const EDITOR_SET_EDIT_PANEL_MODE = 'EDITOR_SET_EDIT_PANEL_MODE';

export const editorClosed = () => ({
  type: EDITOR_CLOSED
});

export const editorCut = scribeId => ({
  type: EDITOR_CUT,
  scribeId
});

export const editorCopy = (scribeId, asCut = false) => ({
  type: EDITOR_COPY,
  scribeId,
  asCut
});

export const editorPaste = (scribeId, inPlace = false) => ({
  type: EDITOR_PASTE,
  scribeId,
  inPlace
});

export const editorUndo = scribeId => ({
  type: EDITOR_UNDO,
  scribeId
});

export const editorUndoSuccess = (newPast, newFuture) => ({
  type: EDITOR_UNDO_SUCCESS,
  newPast,
  newFuture
});

export const editorRedo = scribeId => ({
  type: EDITOR_REDO,
  scribeId
});

export const editorRedoSuccess = (newPast, newFuture) => ({
  type: EDITOR_REDO_SUCCESS,
  newPast,
  newFuture
});

export const editorKeyboardDelete = scribeId => ({
  type: EDITOR_KEYBOARD_DELETE,
  scribeId
});

export const editorSetEditPanelMode = mode => ({
  type: EDITOR_SET_EDIT_PANEL_MODE,
  mode
});
